import { useTranslation } from 'react-i18next';

export default function PersonFormIcons({ activeForm, setActiveForm, showRegisterIcons = false }) {
    const { t } = useTranslation();

    const icons = [
        { id: 'main', image: '/images/person/persons.png', label: 'Main' },
        { id: 'documents', image: '/images/person/personDetail.png', label: 'Documents' },
        { id: 'files', image: '/images/person/folder-documents.png', label: 'Files' },
        { id: 'family', image: '/images/person/personFamily.png', label: 'Family' },
        { id: 'email', image: '/images/person/emails.png', label: 'Email' },
        { id: 'payment', image: '/images/person/personBank.png', label: 'Payment' },
        { id: 'medical', image: '/images/person/personDoctors.png', label: 'Medical' },
        { id: 'education', image: '/images/person/personEducation.png', label: 'Education' },
        { id: 'language', image: '/images/person/language.png', label: 'Language' },
        { id: 'building', image: '/images/person/jobHistory.png', label: 'Building' },
        // TODO: Not sure if we need this icon { id: 'globe', image: '/images/person/personCollect.png', label: 'Globe' },
        { id: 'home', image: '/images/person/House-icon.png', label: 'Home' }
    ];

    // Additional icons that will only show in Register context
    const registerIcons = showRegisterIcons ? [
        { id: 'employeeData', image: '/images/person/employeeData.png', label: 'Current Status' },
        { id: "personContract", image: '/images/person/personContract.png', label: 'Person Contract' },
        { id: 'workExperience', image: '/images/person/workExperience.png', label: 'Work Experience' },
        { id: 'personHolidays', image: '/images/person/personHoliday.png', label: 'Person Holidays' },
        { id: 'empEdit', image: '/images/person/empEdit.png', label: 'Employer Data Editing' }
    ] : [];

    const allIcons = [...registerIcons, ...icons,];

    return (
        <div className="person-action-icons">
            <div className="icon-grid">
                {allIcons.map(icon => (
                    <div 
                        key={icon.id}
                        className={`action-icon ${activeForm === icon.id ? 'active' : ''}`}
                        onClick={() => setActiveForm(icon.id)}
                    >
                        <img src={icon.image} alt={icon.label} />
                        <span>{t(`persons.icons.${icon.id}`) || icon.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}